export const BOOTSTRAP_PROJECTS = 'BOOTSTRAP_PROJECTS'
export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const DELETE_MULTIPLE_PROJECTS = 'DELETE_MULTIPLE_PROJECTS'
export const SET_SELECTED_PROJECTS = 'SET_SELECTED_PROJECTS'
export const SET_TOTAL_PROJECTS = 'SET_TOTAL_PROJECTS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_SELECTED_VIEW_PROJECT = 'SET_SELECTED_VIEW_PROJECT'
